
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1829059498 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1095136170 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1326482070 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b291345679 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b175597986 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n,
      i10 = i.slice(-1), i100 = i.slice(-2);
  return (t0 && i10 == 1 && i100 != 11
          || !t0) ? 'one' : 'other';
});
Globalize.a1319365012 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1331104054 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b801704971 = messageFormatterFn((function(  ) {
  return function(d) { return "Netfang"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1154528956 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1957539613 = messageFormatterFn((function(  ) {
  return function(d) { return "Þetta er almennings- eða samnýtt tæki"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b874032100 = messageFormatterFn((function(  ) {
  return function(d) { return "Ekki þitt tæki? Ef þú velur þennan gátreit styttist tíminn sem þú ert innskráð/ur hér."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1237102519 = messageFormatterFn((function(  ) {
  return function(d) { return "Halda mér innskráðum/innskráðri"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b157730151 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að haka hér verður þú innskráð/ur á reikninginn þinn á þessu tæki þar til þú skráir þig út. Ekki velja þetta á tækjum sem þú deilir með öðrum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a884724063 = messageFormatterFn((function(  ) {
  return function(d) { return "Gleymdirðu aðgangsorðinu?"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a645525328 = messageFormatterFn((function(  ) {
  return function(d) { return "Halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2122573789 = messageFormatterFn((function(  ) {
  return function(d) { return "Hætta við"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1287877510 = messageFormatterFn((function(  ) {
  return function(d) { return "Til baka"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1726733688 = messageFormatterFn((function(  ) {
  return function(d) { return "Endurhlaða"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a348712909 = messageFormatterFn((function(  ) {
  return function(d) { return "Með innskráningu samþykki ég " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">skilmála og skilyrði</a> og <a href=" + d["2"] + " " + d["4"] + ">persónuverndaryfirlýsingu</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b80300619 = messageFormatterFn((function(  ) {
  return function(d) { return "Með innskráningu samþykki ég " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">skilmála og skilyrði</a>, <a href=" + d["2"] + " " + d["6"] + ">persónuverndaryfirlýsingu</a> og <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " skilmála og skilyrði</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1348226051 = messageFormatterFn((function(  ) {
  return function(d) { return "Með innskráningu er ég einnig að tengjast " + d["4"] + ". Ég samþykki " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">skilmála og skilyrði</a>, <a href=" + d["2"] + " " + d["6"] + ">persónuverndaryfirlýsingu</a> og <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " skilmála og skilyrði</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2033922472 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangurinn þinn var settur í bið eftir reglubundna öryggiskönnun. Upplýsingarnar þínar eru öruggar, en þú þarft að endurstilla aðgangsorðið. Gerðu það með hlekknum „Gleymdirðu aðgangsorðinu?“ hér fyrir neðan til að skrá þig inn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1070209042 = messageFormatterFn((function(  ) {
  return function(d) { return "Netfang og aðgangsorð passa ekki saman. Vinsamlegast reyndu aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b638881911 = messageFormatterFn((function(  ) {
  return function(d) { return "Afsakaðu, eitthvað fór úrskeiðis hjá okkur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2079213391 = messageFormatterFn((function(  ) {
  return function(d) { return "Afsakaðu, eitthvað fór úrskeiðis hjá okkur. Bíddu í svolitla stund og reyndu aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b121382547 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn netfangið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2015897854 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn gilt netfang."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b441094212 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn aðgangsorðið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2031149722 = messageFormatterFn((function(  ) {
  return function(d) { return "Sannreyni innskráningarauðkenni"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a44161311 = messageFormatterFn((function(  ) {
  return function(d) { return "Fela aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a358503450 = messageFormatterFn((function(  ) {
  return function(d) { return "Sýna aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a951742436 = messageFormatterFn((function(  ) {
  return function(d) { return "Ertu ekki með reikning? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Stofnaðu reikning</a></span>"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b94937303 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b147400544 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning í gegnum " + d["0"] + " er ekki lengur í boði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1713017732 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú getur notað sama netfang til að fá aðgang að " + d["0"] + "-reikningnum þínum með því að endurstilla aðgangsorðið. Það mun ekki hafa áhrif á " + d["1"] + "-reikninginn þinn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a568743346 = messageFormatterFn((function(  ) {
  return function(d) { return "Endurstilltu aðgangsorðið með því að nota hnappinn hér fyrir neðan. Næst skaltu nota netfangið þitt og nýja aðgangsorðið til að skrá þig beint inn á " + d["0"] + "."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1075049045 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO-innskráning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b854223949 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning með einfaldri innskráningu"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1905914529 = messageFormatterFn((function(  ) {
  return function(d) { return "Eða notaðu " + d["0"] + "-reikninginn þinn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b840944428 = messageFormatterFn((function(  ) {
  return function(d) { return "Fáðu punkta upp í ókeypis ferðir. Sparaðu með félagaverði. Fáðu auðveldan aðgang að ferðaáætlunum þínum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1807649298 = messageFormatterFn((function(  ) {
  return function(d) { return "Fáðu " + d["0"] + " Expedia Rewards-punkta eftir þessa ferð."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1407116363 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráning inn á " + d["0"] + " reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1626090167 = messageFormatterFn((function(  ) {
  return function(d) { return "Gleymt aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a577922446 = messageFormatterFn((function(  ) {
  return function(d) { return "Endurstilling á aðgangsorði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1520584360 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn netfangið þitt og við sendum þér hlekk til að endurstilla aðgangsorðið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b645083372 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda hlekk"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a982031183 = messageFormatterFn((function(  ) {
  return function(d) { return "Kannaðu tölvupóstinn þinn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a353966071 = messageFormatterFn((function(  ) {
  return function(d) { return "Við sendum tölvupóst á " + d["0"] + " með hlekk til að endurstilla aðgangsorðið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a353967032 = messageFormatterFn((function(  ) {
  return function(d) { return "Það gæti tekið tölvupóstinn nokkrar mínútur að berast. Ef þú sérð hann ekki eftir 10 mínútur skaltu kanna ruslpósthólfið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1336809634 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda hlekkinn aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b651626598 = messageFormatterFn((function(  ) {
  return function(d) { return "Nýr hlekkur hefur verið sendur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1468071309 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfesti aðgang"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1147997875 = messageFormatterFn((function(  ) {
  return function(d) { return "Stilla aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b325927964 = messageFormatterFn((function(  ) {
  return function(d) { return "Gott að fá þig aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1316797250 = messageFormatterFn((function(  ) {
  return function(d) { return "Búðu til einkvæmt aðgangsorð til að halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b200566029 = messageFormatterFn((function(  ) {
  return function(d) { return "Það tókst!"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1921543594 = messageFormatterFn((function(  ) {
  return function(d) { return "Nú skaltu nota nýja aðgangsorðið til að koma þér af stað."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a784763483 = messageFormatterFn((function(  ) {
  return function(d) { return "Endurstilling á aðgangsorði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1673715522 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður er þessi beiðni útrunnin. Ef þú þarft enn að breyta aðgangsorðinu þínu skaltu smella hér fyrir neðan til að senda nýjan tölvupóst til að endurstilla aðgangsorðið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1671367890 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda hlekkinn aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b487507587 = messageFormatterFn((function(  ) {
  return function(d) { return "Vista aðgangsorðið þitt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1448393169 = messageFormatterFn((function(  ) {
  return function(d) { return "Stofna reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b985670563 = messageFormatterFn((function(  ) {
  return function(d) { return "Stofna reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1340317678 = messageFormatterFn((function(  ) {
  return function(d) { return "Netfang"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1807257702 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn netfangið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b758304969 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn gilt netfang."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1312254477 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornafn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1666228603 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn fornafn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a662708273 = messageFormatterFn((function(  ) {
  return function(d) { return "Eftirnafn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b126108487 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn eftirnafn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b416398926 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn nafn, eingöngu með bókstöfum"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1513090731 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a724273971 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn aðgangsorðið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1010225470 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast sláðu inn gilt aðgangsorð."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1912205890 = messageFormatterFn((function(  ) {
  return function(d) { return "Inniheldur 9-64 stafi"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1912204929 = messageFormatterFn((function(  ) {
  return function(d) { return "Inniheldur bæði bókstafi og tölur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1912203968 = messageFormatterFn((function(  ) {
  return function(d) { return "Sértákn eins og ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1912203007 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorð getur ekki innihaldið bil"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1389053688 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorðið þitt verður að hafa á milli 8-64 leturtákn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a99359013 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorð getur ekki verið það sama og netfangið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2031312478 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorð getur ekki innihaldið bil."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1696511142 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að stofna reikning samþykki ég " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">skilmála og skilyrði</a> og <a href=" + d["2"] + " " + d["4"] + ">persónuverndaryfirlýsingu</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1509050184 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að stofna reikning samþykki ég " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">skilmála og skilyrði</a>, <a href=" + d["2"] + " " + d["6"] + ">persónuverndaryfirlýsingu</a> og <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " skilmála og skilyrði</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1921678231 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég myndi vilja fá ferðatilboð, sértilboð og aðrar upplýsingar frá " + d["0"] + " í tölvupósti."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1693167450 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég myndi vilja fá ferðatilboð, sértilboð og aðrar upplýsingar frá " + d["0"] + " í tölvupósti. Þú getur hafnað tilboðstölvupóstum hvenær sem er."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b884678036 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég myndi vilja fá hugmyndir um frí, sértilboð og aðrar upplýsingar frá " + d["0"] + " í tölvupósti."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1689841789 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég myndi vilja fá hugmyndir um frí, sértilboð og aðrar upplýsingar frá " + d["0"] + " í tölvupósti. Þú getur hafnað tilboðstölvupóstum hvenær sem er."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b981822281 = messageFormatterFn((function(  ) {
  return function(d) { return "Halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a930376124 = messageFormatterFn((function(  ) {
  return function(d) { return "Áttu nú þegar reikning? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Innskráning</a></span>"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b672916031 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkomin/n " + d["0"]; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b557175067 = messageFormatterFn((function(  ) {
  return function(d) { return "Með nýja " + d["0"] + "-reikningnum þínum er heimurinn í seilingarfjarlægð."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1047111662 = messageFormatterFn((function(  ) {
  return function(d) { return "Halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1757094179 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangsorðið þitt verður að vera sterkara til að halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1553004312 = messageFormatterFn((function(  ) {
  return function(d) { return "Verður að innihalda a.m.k. 8 stafi."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a977004556 = messageFormatterFn((function(  ) {
  return function(d) { return "Styrkleiki aðgangsorðs"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a350104758 = messageFormatterFn((function(  ) {
  return function(d) { return "Veikt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b312732843 = messageFormatterFn((function(  ) {
  return function(d) { return "Sterkt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1556698411 = messageFormatterFn((function(  ) {
  return function(d) { return "Mjög sterkt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b163917158 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu fyrirsjáanlegar útskiptingar á stöfum, eins og t.d. „@“ fyrir „a\"."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b888403838 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu að skrifa algeng orð afturábak."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a614990134 = messageFormatterFn((function(  ) {
  return function(d) { return "Notaðu hástafi, en ekki eingöngu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a443364183 = messageFormatterFn((function(  ) {
  return function(d) { return "Ekki nota einungis hástaf í fyrsta stafnum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a284460197 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu dagsetningar og ártöl sem tengjast þér."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b557976805 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu nýliðin ártöl."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1839525302 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu ártöl sem tengjast þér."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1152982281 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu algengar stafarunur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2002055919 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu endurtekin orð og stafi."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b256412747 = messageFormatterFn((function(  ) {
  return function(d) { return "Notaðu lengri lyklaborðsmynstur og breyttu innsláttarátt mörgum sinnum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a166411418 = messageFormatterFn((function(  ) {
  return function(d) { return "Bættu við fleiri orðum sem eru síður algeng."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a276609414 = messageFormatterFn((function(  ) {
  return function(d) { return "Notaðu mörg orð en forðastu algenga frasa."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b459955607 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú getur búið til sterk aðgangsorð án þess að nota tákn, tölur eða hástafi."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b187556048 = messageFormatterFn((function(  ) {
  return function(d) { return "Þetta netfang er nú þegar tengt reikningi á " + d["0"]; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b364059106 = messageFormatterFn((function(  ) {
  return function(d) { return "Við sendum þér hlekk með tölvupósti sem þú þarft að nota til að klára að búa til reikninginn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1061111987 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráningarbeiðni í vinnslu"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a284727865 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornafn verður að vera minnst tveir bókstafir"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2067621269 = messageFormatterFn((function(  ) {
  return function(d) { return "Eftirnafn verður að vera minnst tveir bókstafir"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1532777703 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornafn getur mest verið 100 bókstafir að lengd"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b979296189 = messageFormatterFn((function(  ) {
  return function(d) { return "Eftirnafn getur mest verið 100 bókstafir að lengd"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a247299618 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornafn getur ekki innihaldið sértákn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b84090242 = messageFormatterFn((function(  ) {
  return function(d) { return "Eftirnafn getur ekki innihaldið sértákn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1313240832 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég samþykki allt neðangreint"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b798527476 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég staðfesti að ég er 18 ára eða eldri og að ég hef farið yfir og samþykkt <a href=" + d["0"] + " " + d["1"] + ">notkunarskilmálana</a> og <a href=" + d["2"] + " " + d["3"] + ">skilmála og skilyrði" + d["4"] + "</a> (áskilið)."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b919713610 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég samþykki söfnun og notkun persónuupplýsinga minna eins og lýst er í <a href=" + d["0"] + " " + d["1"] + ">persónuverndarstefnunni</a> (áskilið)"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1491139753 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég samþykki úthlutun persónuupplýsinga minna til þriðju aðila, annað hvort í Kóreu eða í öðrum löndum, eins og lýst er í <a href=" + d["0"] + " " + d["1"] + ">persónuverndarstefnunni</a> (áskilið)"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1565943572 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast samþykktu skilmálana til að halda áfram."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a519618704 = messageFormatterFn((function(  ) {
  return function(d) { return "Samþykktu skilmálana til að halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1082990732 = messageFormatterFn((function(  ) {
  return function(d) { return "Hakaðu í reitinn til að halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b198641275 = messageFormatterFn((function(  ) {
  return function(d) { return "Eða stofnaðu reikning hjá " + d["0"]; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1563483417 = messageFormatterFn((function(  ) {
  return function(d) { return "Forðastu að nota stafabil, nafnið þitt, netfang eða aðgangsorð sem þú hefur notað áður."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a757979491 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður, eitthvað fór úrskeiðis okkar megin. Bíddu í nokkrar mínútur og reyndu síðan aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1851390967 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfestu farsímanúmerið þitt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b821617478 = messageFormatterFn((function(  ) {
  return function(d) { return "Við sendum einnota staðfestingarkóða í farsímanúmerið þitt til að tryggja að reikningurinn þinn verði áfram öruggur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b535875219 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1464171398 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Allur réttur áskilinn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1351413704 = messageFormatterFn((function(  ) {
  return function(d) { return "Skilmálar og skilyrði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1999535095 = messageFormatterFn((function(  ) {
  return function(d) { return "Persónuvernd"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1531518816 = messageFormatterFn((function(  ) {
  return function(d) { return "Sendu mér textaskilaboð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a937995445 = messageFormatterFn((function(  ) {
  return function(d) { return "Slá inn staðfestingarkóða"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1704837735 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfestingarkóði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b282231718 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda kóða aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1061122929 = messageFormatterFn((function(  ) {
  return function(d) { return "Breyta farsímanúmeri"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1530148765 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfestingarkóði hefur verið endursendur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1475109572 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn 6-stafa staðfestingarkóðann sem við vorum að senda í " + d["0"]; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1074586633 = messageFormatterFn((function(  ) {
  return function(d) { return "Sannreyni staðfestingarkóða"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1291938078 = messageFormatterFn((function(  ) {
  return function(d) { return "Kóðinn er ekki réttur. Endursendu kóða til að reyna aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1687277336 = messageFormatterFn((function(  ) {
  return function(d) { return "eða haltu áfram með"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1851477752 = messageFormatterFn((function(  ) {
  return function(d) { return "Sparaðu að meðaltali " + d["0"] + "% á þúsundum hótela sem félagi — það kostar þig aldrei neitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a124974726 = messageFormatterFn((function(  ) {
  return function(d) { return "eða"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1814180356 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðrar innskráningaraðferðir"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1814539770 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðrar aðferðir til að stofna reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a780145296 = messageFormatterFn((function(  ) {
  return function(d) { return "Stofna í gegnum Google"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a874885743 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning tókst ekki. Reyndu aftur eða búðu til aðgang á þessari síðu til að halda áfram."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1998534423 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning með símanúmeri er ekki í boði. Gakktu úr skugga um að samfélagsmiðlareikningurinn þinn sé stilltur þannig að hann deili netfanginu þínu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1340006431 = messageFormatterFn((function(  ) {
  return function(d) { return "Sparaðu " + d["0"] + "% eða meira á þúsundum hótela sem félagi — það kostar þig aldrei neitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1553600826 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskrá með Google"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1859073275 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskrá með NAVER"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a191064165 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur farið yfir hámarksfjölda innskráningartilrauna. Vinsamlegast reyndu aftur síðar."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1056703176 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráðu þig inn með lífkenni"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a221527016 = messageFormatterFn((function(  ) {
  return function(d) { return "Notaðu lífkenni til að fá aðgang að reikningnum þínum svo þú þurfir ekki að skrá inn aðgangsorð."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a10600277 = messageFormatterFn((function(  ) {
  return function(d) { return "Byrja"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b570014789 = messageFormatterFn((function(  ) {
  return function(d) { return "Minna mig á síðar"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a23185647 = messageFormatterFn((function(  ) {
  return function(d) { return "Það tókst!"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b272582997 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning með lífkenni hefur verið virkjuð."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b639315053 = messageFormatterFn((function(  ) {
  return function(d) { return "Skrá inn með lífkenni"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1622955752 = messageFormatterFn((function(  ) {
  return function(d) { return "Nota aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a774653885 = messageFormatterFn((function(  ) {
  return function(d) { return "Nota lífkenni"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2039691882 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppfærðu aðgangsorðið til að halda áfram"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1387818926 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú þarft að endurstilla aðgangsorðið til að fá aðgang að reikningnum þínum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b745242120 = messageFormatterFn((function(  ) {
  return function(d) { return "Endurstilling á aðgangsorði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a779444232 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkomin/n í félagaávinning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1574611154 = messageFormatterFn((function(  ) {
  return function(d) { return "Byrjaðu næsta ævintýri með punktagjöf frá okkur sem nemur $" + d["0"] + "!"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1145071678 = messageFormatterFn((function(  ) {
  return function(d) { return "Punktarnir eru aðgengilegir nú þegar á reikningnum þínum og hægt að nota þá við fyrstu bókun. Leitaðu einfaldlega að möguleikanum á að nota punktana á greiðslusíðunni."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a640058864 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú ert nú Expedia-félagi."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1209777856 = messageFormatterFn((function(  ) {
  return function(d) { return "Byrjaðu tafarlaust að spara með félagaverðum og ávinna þér punkta þegar þú bókar."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1056322101 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráðu þig inn eða stofnaðu reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2080202619 = messageFormatterFn((function(  ) {
  return function(d) { return "Sparaðu að meðaltali " + d["0"] + "% á þúsundum hótela sem félagi — það kostar þig aldrei neitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1133007075 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að halda áfram staðfestir þú að hafa lesið og samþykkt <a href=" + d["1"] + " " + d["3"] + ">skilmála okkar og skilyrði</a> og <a href=" + d["2"] + " " + d["4"] + ">persónuverndarstefnu</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b855287707 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að halda áfram staðfestir þú að hafa lesið og samþykkt <a href=" + d["1"] + " " + d["5"] + ">skilmála okkar og skilyrði</a>, <a href=" + d["2"] + " " + d["6"] + ">persónuverndarstefnu</a> og <a href=" + d["3"] + " " + d["7"] + ">skilmála og skilyrði " + d["4"] + "</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a3954112 = messageFormatterFn((function(  ) {
  return function(d) { return "Með því að halda áfram staðfestir þú að hafa lesið og samþykkt <a href=" + d["1"] + " " + d["4"] + ">skilmála okkar og skilyrði</a>, <a href=" + d["2"] + " " + d["5"] + ">persónuverndarstefnu</a> og <a href=" + d["3"] + " " + d["6"] + ">skilmála og skilyrði One Key-vildarkerfisins</a>."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1520619044 = messageFormatterFn((function(  ) {
  return function(d) { return "Netfang"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2091956062 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn gilt netfang"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a767795809 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1654794350 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b698499640 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1974795553 = messageFormatterFn((function(  ) {
  return function(d) { return "Þetta er einungis fyrir persónuleg tæki. Til að tryggja öryggi reikningsins þíns skaltu ekki haka við þetta á tækjum sem eru samnýtt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1598700306 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútur áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b477118410 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútu áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b472223076 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútur áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b485680920 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútur áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1974682907 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútur áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1227271456 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú hefur reynt að innskrá þig of oft. Þú þarft að bíða í " + d["0"] + " mínútur áður en þú getur reynt aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1849972977 = messageFormatterFn((function(  ) {
  return function(d) { return "Afhjúpaðu heilan heim ferðaávinninga með einum og sama reikningnum á Expedia, Hotels.com og Vrbo."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a323820617 = messageFormatterFn((function(  ) {
  return function(d) { return "Afhjúpaðu heilan heim ferðalaga með einum og sama reikningnum á Expedia, Hotels.com og Vrbo."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1650875696 = messageFormatterFn((function(  ) {
  return function(d) { return "Skoðaðu og vistaðu gististaði, skipuleggðu með hópnum þínum og fáðu aðgang að bókunarupplýsingum."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2003471665 = messageFormatterFn((function(  ) {
  return function(d) { return "Aðgangurinn þinn var settur í bið eftir reglubundna öryggiskönnun. Upplýsingarnar þínar eru öruggar, en þú þarft að endurstilla aðgangsorðið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1931419199 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráðu þig inn og bókaðu dvöl til að ávinna þér OneKeyCash"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a172161715 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfestum auðkenni þitt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1067835577 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn öryggiskóðann sem við sendum þér með tölvupósti. Skoðaðu ruslpósthólfið ef þú finnur ekkert í innhólfinu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1968991035 = messageFormatterFn((function(  ) {
  return function(d) { return "Staðfestum netfangið þitt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a704869365 = messageFormatterFn((function(  ) {
  return function(d) { return "Til að halda áfram skaltu slá inn öryggiskóðann sem við sendum á " + d["0"] + ". Skoðaðu ruslpósthólfið ef þú finnur ekkert í innhólfinu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b524302607 = messageFormatterFn((function(  ) {
  return function(d) { return "6-stafa kóði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a585859569 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda kóða aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a803105672 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2147266896 = messageFormatterFn((function(  ) {
  return function(d) { return "Endursending kóða eftir " + d["0"] + " sek."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1135978912 = messageFormatterFn((function(  ) {
  return function(d) { return "Fékkstu ekki tölvupóst?"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b816418562 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú getur beðið um annan kóða eftir " + d["0"] + " sek."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1376846059 = messageFormatterFn((function(  ) {
  return function(d) { return "Biðja um annan öryggiskóða"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1867127883 = messageFormatterFn((function(  ) {
  return function(d) { return "Við sendum nýjan 6 stafa kóða í innhólfið þitt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1398588992 = messageFormatterFn((function(  ) {
  return function(d) { return "Slá inn aðgangsorð í staðinn"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1157143295 = messageFormatterFn((function(  ) {
  return function(d) { return "Ógildur kóði, vinsamlegast reyndu aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2029325359 = messageFormatterFn((function(  ) {
  return function(d) { return "Kóði útrunninn, vinsamlegast endursendu og reyndu aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1982038108 = messageFormatterFn((function(  ) {
  return function(d) { return "Skoðaðu ruslpósthólfið ef þú finnur ekkert í innhólfinu"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a307511563 = messageFormatterFn((function(  ) {
  return function(d) { return "Við uppfærðum kerfið okkar og þurfum að staðfesta netfangið þitt. Sláðu inn öryggiskóðann sem við sendum þér með tölvupósti."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1526845932 = messageFormatterFn((function(  ) {
  return function(d) { return "Eitthvað fór úrskeiðis hjá okkur. Vinsamlegast reyndu aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1791996195 = messageFormatterFn((function(  ) {
  return function(d) { return "Til að uppfæra innskráningaraðferðina skaltu slá inn öryggiskóðann sem við sendum þér með tölvupósti."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a880668809 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn aðgangsorðið þitt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2105557566 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda öryggiskóða með tölvupósti"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a780386398 = messageFormatterFn((function(  ) {
  return function(d) { return "Netfang og aðgangsorð passa ekki saman"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1379849433 = messageFormatterFn((function(  ) {
  return function(d) { return "Búðu til aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1257832623 = messageFormatterFn((function(  ) {
  return function(d) { return "Búðu til aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b248549911 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú getur notað sama netfang og aðgangsorð til að skrá þig inn á Expedia, Hotels.com og Vrbo."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a156637847 = messageFormatterFn((function(  ) {
  return function(d) { return "Búa til aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a808147174 = messageFormatterFn((function(  ) {
  return function(d) { return "Veldu aðgangsorð til að nota í viðbót við aðrar öruggar innskráningarleiðir."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1694551781 = messageFormatterFn((function(  ) {
  return function(d) { return "Stilltu nýtt aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1255888965 = messageFormatterFn((function(  ) {
  return function(d) { return "Stilltu nýtt aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1018494859 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú getur núna notað einn og sama reikninginn til að skrá þig inn á Expedia, Hotels.com og Vrbo. Búðu til nýtt, öruggt aðgangsorð fyrir sameinaða reikninginn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2147019915 = messageFormatterFn((function(  ) {
  return function(d) { return "Búa til aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a584418941 = messageFormatterFn((function(  ) {
  return function(d) { return "Breyta aðgangsorði"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1683798099 = messageFormatterFn((function(  ) {
  return function(d) { return "Notaðu sterkt aðgangsorð sem þú notar hvergi annars staðar."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1289535469 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppfæra aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a658871258 = messageFormatterFn((function(  ) {
  return function(d) { return "Við gátum ekki uppfært aðgangsorðið þitt. Vinsamlegast reyndu aftur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2093548424 = messageFormatterFn((function(  ) {
  return function(d) { return "Gleymt aðgangsorð"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a867437410 = messageFormatterFn((function(  ) {
  return function(d) { return "Sláðu inn netfangið þitt og við sendum þér öryggiskóða til að skrá þig inn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b806920578 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda tölvupóst"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b552239670 = messageFormatterFn((function(  ) {
  return function(d) { return "Hafa samband"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a638442085 = messageFormatterFn((function(  ) {
  return function(d) { return "Eyða gögnum"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b753336998 = messageFormatterFn((function(  ) {
  return function(d) { return "Loka"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a387907454 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast hinkraðu á meðan við könnum reikninginn þinn."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a106942465 = messageFormatterFn((function(  ) {
  return function(d) { return "Reikningseyðing"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1956546405 = messageFormatterFn((function(  ) {
  return function(d) { return "Skilið"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1096822847 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður getur þú ekki eytt þar til ferðin er yfirstaðin."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b785050848 = messageFormatterFn((function(  ) {
  return function(d) { return "Til að tryggja að ferðin gangi vel fyrir sig þarftu reikninginn til að fá aðgang að bókuninni og fá aðstoð hjá þjónustudeild okkar ef breytingar verða á síðustu stundu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b871356813 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður þarftu fyrst að eyða Vrbo-eigandareikningnum þínum"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1029152284 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast farðu á hjálparmiðstöð okkar eða í appið til að hafa beint samband við þjónustudeild okkar svo hægt sé að hefja ferlið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a791769108 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast reyndu aftur eftir að ferðinni er lokið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b625391055 = messageFormatterFn((function(  ) {
  return function(d) { return "Segðu okkur hvers vegna þú vilt fara"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1620775742 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég fæ of marga tölvupósta eða tilkynningar"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1053313748 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég er með annan " + d["0"] + "-reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1132881935 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferðin mín er búin svo ég þarf ekki þennan reikning"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1348549227 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég hef slæma reynslu af því að bóka með " + d["0"]; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b367403862 = messageFormatterFn((function(  ) {
  return function(d) { return "Annað"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b172968237 = messageFormatterFn((function(  ) {
  return function(d) { return "Loka"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b783053158 = messageFormatterFn((function(  ) {
  return function(d) { return "Senda"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b506270294 = messageFormatterFn((function(  ) {
  return function(d) { return "Okkur þykir leitt að kveðja þig. Hér eru nokkur atriði sem þú ættir að hafa í huga:"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a371471907 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " Expedia Rewards-punktum að andvirði " + d["1"] + ", inneign að andvirði " + d["2"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1057537838 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " Expedia Rewards-punktum að andvirði " + d["1"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1187190192 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa ferðaspjöldum þínum, inneign og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1939705446 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Þú munt tapa " + d["0"] + " verðlaunanóttum að andvirði " + d["1"] + " og " + d["2"] + " stimplum sem eru með meðalvirði upp á " + d["3"] + "."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a718483831 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa inneign, afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b886023905 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " CheapCash að andvirði " + d["1"] + ", inneign að andvirði " + d["2"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1431447218 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " CheapCash að andvirði " + d["1"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b889365929 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " Orbucks að andvirði " + d["1"] + ", inneign að andvirði " + d["2"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1008291206 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " Orbucks að andvirði " + d["1"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1242240925 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " MrJet Rewards að andvirði " + d["1"] + ", inneign að andvirði " + d["2"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a245245166 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " MrJet Rewards að andvirði " + d["1"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1520395841 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " BONUS+ að andvirði " + d["1"] + ", inneign að andvirði " + d["2"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1971405330 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " BONUS+ að andvirði " + d["1"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a527726665 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b2036623074 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa inneign að andvirði " + d["0"] + ", afsláttarmiðum, vistuðum atriðum í ferðum og reikningsstillingum að eilífu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2033664600 = messageFormatterFn((function(  ) {
  return function(d) { return "Við gætum geymt ákveðnar upplýsingar með öruggum hætti, eins og t.d. skrá yfir færslur þínar, til að uppfylla lagalegar skyldur eða ef við þurfum að stofna, hafa uppi eða verja réttarkröfur. Þessum upplýsingum verður haldið eftir með öruggum hætti og þeim verður eytt, þær gerðar nafnlausar eða ónothæfar til frambúðar þegar ekki er lengur þörf á þeim."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b502880876 = messageFormatterFn((function(  ) {
  return function(d) { return "Eyða reikningi fyrir fullt og allt"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a503251100 = messageFormatterFn((function(  ) {
  return function(d) { return "Ekki eyða reikningi"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b295773422 = messageFormatterFn((function(  ) {
  return function(d) { return "Við vonumst til að sjá þig aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a959730995 = messageFormatterFn((function(  ) {
  return function(d) { return "Það gæti tekið nokkrar vikur að afgreiða beiðni þína um að eyða reikningnum, svo þú gætir haldið áfram að fá skilaboð frá okkur á meðan kerfi okkar uppfærast."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b949363187 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast reyndu aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1234184884 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerfisvilla kom upp. Sendu aftur inn eyðingarbeiðnina eða prófaðu aftur eftir nokkrar mínútur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b756336900 = messageFormatterFn((function(  ) {
  return function(d) { return "Loka"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a381681877 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvaða nafn notarðu á ferðaskilríkjunum þínum?"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a913946075 = messageFormatterFn((function(  ) {
  return function(d) { return "Hafðu nafnið á reikningnum þínum það sama og er á skilríkjunum sem þú notar við ferðalög (t.d. vegabréfi). Við verðum með það tilbúið næst þegar þú bókar."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a188280265 = messageFormatterFn((function(  ) {
  return function(d) { return "Fá tilboð og aðrar upplýsingar frá " + d["0"] + " með tölvupósti."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2098144070 = messageFormatterFn((function(  ) {
  return function(d) { return "Fá tilboð og aðrar upplýsingar frá " + d["0"] + " með tölvupósti. Þú getur afskráð þig frá markaðstölvupóstum hvenær sem er."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1921278207 = messageFormatterFn((function(  ) {
  return function(d) { return "Reikningsupplýsingar"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1679468009 = messageFormatterFn((function(  ) {
  return function(d) { return "Fáðu tölvupóst um tilboð og aðrar upplýsingar frá " + d["0"] + ". Þú getur afskráð þig hvenær sem er."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b144679245 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertu með allt á hreinu"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b463447213 = messageFormatterFn((function(  ) {
  return function(d) { return "Samþykki fyrir markaðssetningu"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b65495198 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a370597696 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1313295672 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2113493088 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2015401314 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b152600249 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a345721829 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1096325906 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður þarftu að bíða þar til ferðinni er lokið"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1955118082 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður þarftu að bíða þar til væntanlegum ferðum lýkur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1012533764 = messageFormatterFn((function(  ) {
  return function(d) { return "Reikningurinn þinn gerir þér kleift að fá aðgang að bókunarupplýsingum og aðstoð ef þörf er á. Vinsamlegast reyndu aftur eftir að ferðinni er lokið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a12456936 = messageFormatterFn((function(  ) {
  return function(d) { return "Reikningurinn þinn gerir þér kleift að fá aðgang að bókunarupplýsingum og aðstoð ef þörf er á. Vinsamlegast reyndu aftur eftir að ferðunum er lokið."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b102998175 = messageFormatterFn((function(  ) {
  return function(d) { return "Því miður er ekki hægt að eyða reikningnum þínum eins og er"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b32804533 = messageFormatterFn((function(  ) {
  return function(d) { return "Þessi reikningur er einnig notaður til að bjóða gististaði til leigu á Vrbo. Áður en þú getur eytt reikningnum þínum þarftu að skrá þig inn á Vrbo-vefnum eða Vrbo Owner-appinu til að fjarlægja skráningar sem þú ert með virkar."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a828307332 = messageFormatterFn((function(  ) {
  return function(d) { return "Vinsamlegast segðu okkur hvers vegna þú ætlar að hætta."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1127894553 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég er með reikning á öðru netfangi"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1324046312 = messageFormatterFn((function(  ) {
  return function(d) { return "Ég hef slæma reynslu af bókun"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1514429501 = messageFormatterFn((function(  ) {
  return function(d) { return "Okkur þykir leitt að þú sért að hætta. Athugaðu að ekki er hægt að afturkalla eyðingu reiknings og hún mun hafa áhrif á gögn þín hjá Expedia, Hotels.com og Vrbo. Hér eru nokkur atriði sem þú ættir að hafa í huga:"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b245798072 = messageFormatterFn((function(  ) {
  return function(d) { return "Okkur þykir leitt að þú sért að hætta. Athugaðu að ekki er hægt að afturkalla eyðingu reiknings og hún mun hafa áhrif á gögn þín hjá Expedia, Wotif, Hotels.com og Vrbo. Hér eru nokkur atriði sem þú ættir að hafa í huga:"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a792463839 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt glata reikningssögu þinni, stillingum og vistuðum atriðum á vefsvæðum Expedia, Hotels.com og Vrbo fyrir fullt og allt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a13424490 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt glata reikningssögu þinni, stillingum og vistuðum atriðum á vefsvæðum Expedia, Wotif, Hotels.com og Vrbo fyrir fullt og allt."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1811180755 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllu OneKeyCash, þar á meðal væntanlegu OneKeyCash, auk stöðu þinnar í One Key-þrepi ásamt öllum ávinningi þess."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1891154871 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllu væntanlegu OneKeyCash, auk stöðu þinnar í One Key-þrepi ásamt öllum ávinningi þess."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a934841282 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa " + d["0"] + " í OneKeyCash og öllu væntanlegu OneKeyCash auk stöðu þinnar í One Key-þrepi ásamt öllum ávinningi þess."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b266836140 = messageFormatterFn((function(  ) {
  return function(d) { return "Korthafar Hotels.com Rewards kreditkorta munu ekki lengur fá ávinning fyrir kortafærslur."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a370731057 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllum Expedia Rewards-punktum, þar á meðal öllum staðfestum og væntanlegum Expedia Rewards-punktum, Hotels.com Rewards-stimplum og verðlaunanóttum og vildarþrepsstöðu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a480711847 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllum væntanlegum Expedia Rewards-punktum, Hotels.com Rewards-stimplum og verðlaunanóttum og vildarþrepsstöðu."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a895623853 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllum afsláttarmiðum og inneign fyrir Expedia, Hotels.com og Vrbo."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2034539960 = messageFormatterFn((function(  ) {
  return function(d) { return "Þú munt tapa að eilífu öllum afsláttarmiðum og inneign fyrir Expedia, Wotif, Hotels.com og Vrbo."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b705545978 = messageFormatterFn((function(  ) {
  return function(d) { return "Það gæti tekið nokkrar vikur að afgreiða beiðni þína um að eyða reikningnum þínum hjá Expedia, Hotels.com og Vrbo, svo þú gætir haldið áfram að fá skilaboð frá okkur á meðan kerfi okkar uppfærast."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1695101615 = messageFormatterFn((function(  ) {
  return function(d) { return "Það gæti tekið nokkrar vikur að afgreiða beiðni þína um að eyða reikningnum þínum hjá Expedia, Wotif, Hotels.com og Vrbo, svo þú gætir haldið áfram að fá skilaboð frá okkur á meðan kerfi okkar uppfærast."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b804577925 = messageFormatterFn((function(  ) {
  return function(d) { return "Lokað verður fyrir One Key Card þegar þú eyðir reikningnum þínum og þú munt ekki lengur safna OneKeyCash fyrir kaup sem þú gerir. Wells Fargo mun hafa samband við þig til að staðfesta lokun kortsins."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1610308721 = messageFormatterFn((function(  ) {
  return function(d) { return "Lokað verður fyrir One Key+ Card þegar þú eyðir reikningnum þínum og þú munt ekki lengur safna OneKeyCash fyrir kaup sem þú gerir. Wells Fargo mun hafa samband við þig til að staðfesta lokun kortsins."; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b865037572 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráðu þig inn eða búðu til reikning til að fá OneKeyCash fyrir ferðina"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1792004002 = messageFormatterFn((function(  ) {
  return function(d) { return "Skráðu þig inn eða búðu til reikning til að fá ávinning fyrir þessa dvöl"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1268182395 = messageFormatterFn((function(  ) {
  return function(d) { return "Ganga frá bókun sem gestur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b1666269069 = messageFormatterFn((function(  ) {
  return function(d) { return "Innskráning á " + d["0"] + ": Bæta við farsímanúmeri"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2087881821 = messageFormatterFn((function(  ) {
  return function(d) { return "Eitthvað fór úrskeiðis"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a2042882761 = messageFormatterFn((function(  ) {
  return function(d) { return "Reyndu að skrá þig inn aftur"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.a1294183872 = messageFormatterFn((function(  ) {
  return function(d) { return "Í lagi"; }
})(), Globalize("is-IS").pluralGenerator({}));
Globalize.b800946440 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1915492808 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1911619445 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1260893893 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1861351784 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a837051021 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b63629768 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1807210760 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1277716488 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a2141776459 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1715195544 = dateToPartsFormatterFn({"2":Globalize("is-IS").numberFormatter({"raw":"00"}),"4":Globalize("is-IS").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b110940569 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"Þ","wed":"M","thu":"F","fri":"F","sat":"L"}}}});
Globalize.a1104769080 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"sunnudagur","mon":"mánudagur","tue":"þriðjudagur","wed":"miðvikudagur","thu":"fimmtudagur","fri":"föstudagur","sat":"laugardagur"}}}});
Globalize.b148476360 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janúar","2":"febrúar","3":"mars","4":"apríl","5":"maí","6":"júní","7":"júlí","8":"ágúst","9":"september","10":"október","11":"nóvember","12":"desember"}}}});
Globalize.b1313324632 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a757451691 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"}),"2":Globalize("is-IS").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a795969334 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maí","6":"jún.","7":"júl.","8":"ágú.","9":"sep.","10":"okt.","11":"nóv.","12":"des."}}}});
Globalize.b1114115565 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janúar","2":"febrúar","3":"mars","4":"apríl","5":"maí","6":"júní","7":"júlí","8":"ágúst","9":"september","10":"október","11":"nóvember","12":"desember"}}}});
Globalize.a1879176962 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"janúar","2":"febrúar","3":"mars","4":"apríl","5":"maí","6":"júní","7":"júlí","8":"ágúst","9":"september","10":"október","11":"nóvember","12":"desember"}}}});
Globalize.b1740557346 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"janúar","2":"febrúar","3":"mars","4":"apríl","5":"maí","6":"júní","7":"júlí","8":"ágúst","9":"september","10":"október","11":"nóvember","12":"desember"}}}});
Globalize.b1739872153 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maí","6":"jún.","7":"júl.","8":"ágú.","9":"sep.","10":"okt.","11":"nóv.","12":"des."}}}});
Globalize.b959376266 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"sunnudagur","mon":"mánudagur","tue":"þriðjudagur","wed":"miðvikudagur","thu":"fimmtudagur","fri":"föstudagur","sat":"laugardagur"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maí","6":"jún.","7":"júl.","8":"ágú.","9":"sep.","10":"okt.","11":"nóv.","12":"des."}}}});
Globalize.b1121503733 = dateToPartsFormatterFn({"1":Globalize("is-IS").numberFormatter({"raw":"0"})}, {"pattern":"E, d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"sun.","mon":"mán.","tue":"þri.","wed":"mið.","thu":"fim.","fri":"fös.","sat":"lau."}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maí","6":"jún.","7":"júl.","8":"ágú.","9":"sep.","10":"okt.","11":"nóv.","12":"des."}}}});
Globalize.b422232689 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1536779057 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b96702238 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1219156196 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1482638033 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1642999068 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a315083983 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1428497009 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b899002737 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b338273630 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a2093909295 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b262113936 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a268608527 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b984636913 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b730041039 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"d"}));
Globalize.a366044610 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1223827903 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b735401814 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a734401355 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1361843595 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1361158402 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1577106817 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b742789982 = dateFormatterFn(Globalize("is-IS").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1191829054 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a77282686 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b886083247 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b2008537205 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a131423710 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1862587219 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1929145726 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a185564734 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a715059006 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1127654639 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b586996258 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1544020833 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^Þ/],["wed",/^M/],["thu",/^F/],["fri",/^F/],["sat",/^L/]]});
Globalize.b642960386 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^miðvikudagur/],["tue",/^þriðjudagur/],["thu",/^fimmtudagur/],["sat",/^laugardagur/],["sun",/^sunnudagur/],["fri",/^föstudagur/],["mon",/^mánudagur/]]});
Globalize.b1896205826 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^nóvember/],["12",/^desember/],["2",/^febrúar/],["10",/^október/],["1",/^janúar/],["4",/^apríl/],["8",/^ágúst/],["3",/^mars/],["6",/^júní/],["7",/^júlí/],["5",/^maí/]]});
Globalize.a2007139234 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a521647601 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1772146896 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jún\./],["7",/^júl\./],["8",/^ágú\./],["9",/^sep\./],["10",/^okt\./],["11",/^nóv\./],["12",/^des\./],["5",/^maí/]]});
Globalize.a878659929 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^nóvember/],["12",/^desember/],["2",/^febrúar/],["10",/^október/],["1",/^janúar/],["4",/^apríl/],["8",/^ágúst/],["3",/^mars/],["6",/^júní/],["7",/^júlí/],["5",/^maí/]]});
Globalize.b769292164 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^nóvember/],["12",/^desember/],["2",/^febrúar/],["10",/^október/],["1",/^janúar/],["4",/^apríl/],["8",/^ágúst/],["3",/^mars/],["6",/^júní/],["7",/^júlí/],["5",/^maí/]]});
Globalize.a252218148 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^nóvember/],["12",/^desember/],["2",/^febrúar/],["10",/^október/],["1",/^janúar/],["4",/^apríl/],["8",/^ágúst/],["3",/^mars/],["6",/^júní/],["7",/^júlí/],["5",/^maí/]]});
Globalize.a252903341 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jún\./],["7",/^júl\./],["8",/^ágú\./],["9",/^sep\./],["10",/^okt\./],["11",/^nóv\./],["12",/^des\./],["5",/^maí/]]});
Globalize.a777400176 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^miðvikudagur/],["tue",/^þriðjudagur/],["thu",/^fimmtudagur/],["sat",/^laugardagur/],["sun",/^sunnudagur/],["fri",/^föstudagur/],["mon",/^mánudagur/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jún\./],["7",/^júl\./],["8",/^ágú\./],["9",/^sep\./],["10",/^okt\./],["11",/^nóv\./],["12",/^des\./],["5",/^maí/]]});
Globalize.a871271761 = dateParserFn(Globalize("is-IS").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^sun\./],["mon",/^mán\./],["tue",/^þri\./],["wed",/^mið\./],["thu",/^fim\./],["fri",/^fös\./],["sat",/^lau\./]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jún\./],["7",/^júl\./],["8",/^ágú\./],["9",/^sep\./],["10",/^okt\./],["11",/^nóv\./],["12",/^des\./],["5",/^maí/]]});
module.exports = Globalize;
